import * as datastore from '@/datastore'

export interface Coupon extends datastore.Reference {
	description: string
	expirationDate?: number
	promoItems: PromoItem[]
	title: string
}

export interface PromoItem {
	brandId?: string
	pantryItemId?: string
}

export const defaultCoupon: Readonly<Coupon> = {
	$id: '',
	description: '',
	promoItems: [],
	title: '',
}
